import styled from 'styled-components/macro';

const GridSchedulerContent = styled.div`
  align-items: stretch;
  display: flex;
  flex: 1 1 auto;
  font-size: 14px;
  overflow: hidden;
`;

export default GridSchedulerContent;
